define('validatorNIF',[],function () {
    return function (value) {

        var tabControl1 = ['1', '2', '3', '5', '6', '8'];
        var tabControl2 = ['45', '70', '71', '72', '77', '79', '90', '91', '98', '99'];
        var check1 = tabControl1.indexOf(value.substr(0,1));
        var check2 = tabControl2.indexOf(value.substr(0,2));

        if(!value || value.length === 0){
            return false;
        }

        if(check1 == -1 && check2 == -1) {
            return false;
        }

        var total = 0;
        for(var $i=0;$i < 8;$i++) {
            total += value.substr($i,1) * (9 - $i);
        }

        var comparateur = 0;
        if(total % 11 != 1 && total % 11 != 0) {
            comparateur = 11 - (total % 11);
        }

        if(value.substr(8,1) != comparateur) {
            return false;
        }

        return true;
    }
});
